module.exports = __webpack_public_path__ + "static/img/aboutUs.d2dd104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/aboutUs.jpg
// module id = XWIN
// module chunks = 1